import { createSlice, nanoid, type PayloadAction } from '@reduxjs/toolkit';

export interface Toast {
  id: string;
  message: string;
  tone: 'success' | 'error' | 'info';
}

interface UiState {
  activeLocationId: string | null;
  navOpen: boolean;
  toasts: Toast[];
}

const initialState: UiState = { activeLocationId: null, navOpen: false, toasts: [] };

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setActiveLocation: (state, action: PayloadAction<string | null>) => {
      state.activeLocationId = action.payload;
    },
    toggleNav: (state, action: PayloadAction<boolean | undefined>) => {
      state.navOpen = action.payload ?? !state.navOpen;
    },
    pushToast: {
      reducer: (state, action: PayloadAction<Toast>) => {
        state.toasts.push(action.payload);
      },
      prepare: (message: string, tone: Toast['tone'] = 'info') => ({
        payload: { id: nanoid(), message, tone }
      })
    },
    dismissToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
    }
  }
});

export const { setActiveLocation, toggleNav, pushToast, dismissToast } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
